import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReadyToMove() {
  return <section data-section-id="225240" id="ready-to-move" className="dark bg-background text-foreground relative overflow-hidden py-32 sm:py-48">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[600px] h-[600px] sm:w-[800px] sm:h-[800px] bg-primary/5 rounded-lg blur-[100px] sm:blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center">
          <h2 className="text-5xl sm:text-6xl md:text-7xl font-default font-bold tracking-tighter mb-12 leading-[1.1]">
            Your Next Home is Closer Than You Think.
          </h2>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center w-full sm:w-auto">
            <Button asChild size="lg" className="w-full sm:w-auto rounded-md h-14 px-10 text-base font-default font-semibold tracking-wide uppercase bg-primary text-primary-foreground shadow-lg hover:shadow-xl transition-all">
              <Link to="/ListYourPropertyPage">Create Free Account</Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-md h-14 px-10 text-base font-default font-semibold tracking-wide uppercase border-primary/30 text-foreground hover:bg-primary/10 hover:border-primary/50 transition-colors">
              <Link to="/FindHomePage">Browse Listings</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}